/**
* @file 页面
*/
<template>
  <div v-loading="isLoading" class="p-reset-password">
    <div class="p-reset-password-card">
      <div v-if="currentFormType === formEnum.RE_PASSWORD">
        <div class="p-reset-password-card__desc">
          <plv-icon
            class="p-re-lock"
            icon="lock"
          />
          <span>设置新的密码</span>
        </div>
        <div class="p-reset-dash"></div>
        <div
          class="p-reset-password-form"
          @keydown.enter="handleSubmit('submit')"
        >
          <plv-form
            ref="loginForm"
            :model="form"
            :rules="rules"
          >
            <plv-form-item
              prop="password"
              required
            >
              <plv-input
                v-model="form.password"
                type="password"
                placeholder="请输入新密码"
              />
            </plv-form-item>
            <plv-form-item
              prop="confirmPassword"
              required
            >
              <plv-input
                v-model="form.confirmPassword"
                placeholder="确认新密码"
                type="password"
              />
            </plv-form-item>
            <plv-form-item>
              <plv-button @click="handleSubmit('submit')">提交</plv-button>
            </plv-form-item>
          </plv-form>
        </div>
      </div>
      <div v-else-if="currentFormType === formEnum.RE_SUCCESS">
        <div class="p-reset-password-success">
          <div class="p-reset-password-title">
            <plv-icon
              class="p-re-lock"
              icon="lock"
            />
            <span>密码修改成功</span>
          </div>
          <div class="p-reset-new-pwd">您现在可以使用新密码登录您的账号了。</div>
          <plv-button @click="handleSubmit('login')">登录账号</plv-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonType, formEnum } from './constant';
import { objectToFormData } from '@/utils/utils';
import { defaultFormRules } from '@/utils/type';

export default {
  data() {
    return {
      currentFormType: formEnum.RE_PASSWORD,
      formEnum,
      isLoading: false,
      form: {
        password: '',
        confirmPassword: '',
      },
      rules: Object.assign({
        confirmPassword: {
          validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error('两次密码输入不一致'));
            }
            callback();
          }
        },
      }, defaultFormRules)
    };
  },

  mounted() {
    const url = new URL(window.location.href);
    const ts = url.searchParams.get('ts') ?? 0;
    if (Date.now() > +ts + (1000 * 60 * 3)) {
      this.$toast.warning('重置地址失效, 请重新发送邮件');
    }
  },
  methods: {
    async handleSubmit(type) {
      if (type === buttonType.SUBMIT) {
        try {
          this.isLoading = true;
          await this.$refs.loginForm.validate();

          const url = new URL(window.location.href);
          await this.$store.dispatch('account/resetPassword', objectToFormData({
            ...this.form,
            email: url.searchParams.get('email'),
            token: url.searchParams.get('token'),
          }));
          this.currentFormType = formEnum.RE_SUCCESS;
        } finally {
          this.isLoading = false;
        }
      } else {
        this.$router.push('/');
      }
    },
  },
};
</script>
<style lang="scss">
.p-reset-password {
  min-width: 1170px;
  height: 100%;
  background: url('../../assets/images/login_bg.png') no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .p-reset-password-card {
    width: 480px;
    height: 380px;
    background: #fff;
    border-radius: 4px;

    &__desc {
      width: 100%;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #246AF4;

      .p-re-lock {
        font-size: 35px;
      }
      span {
        font-size: 23px;
      }

      &__logo {
        width: 200px;
        height: 42px;
        background: url('../../assets/images/logo.png') no-repeat;
        background-size: contain;
        margin: 0 auto;
      }

      &__welcome {
        font-size: 16px;
        text-align: center;
        margin-top: 20px;
      }
    }

    .p-reset-dash {
      border: 1px solid #b5b0b0;
    }

    .p-reset-password-form, .p-reset-password-success {
      padding: 100px 91px 40px 91px;
      margin: 0 auto;

      .plv-button {
        width: 100%;
      }
    }
    .p-reset-password-success {
      .p-reset-password-title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #246AF4;

        .p-re-lock {
          font-size: 35px;
        }
        span {
          font-size: 23px;
        }
      }
      .p-reset-new-pwd {
        text-align: center;
        margin: 20px 0 30px 0;
      }
    }
  }
}
</style>
